import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiBaseUrl, apiKey } from '../../../utils/config';


// Create an asynchronous thunk to fetch account details
export const fetchAccountDetails = createAsyncThunk(
  'accountDetails/fetchAccountDetails',
  async (account, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${apiBaseUrl}/trade/account-detail`,
        {
          api_key: apiKey,
          account
        },
        {
          headers: {
            "Trade-Account-Token": token
          }
        }
      );

      const res = response.data;
      return res.data;
    } catch (error) {
      console.error("Error fetching account details:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


  // Create the account details slice
const accountDetailsSlice = createSlice({
    name: 'accountDetails',
    initialState: {
      account: null,
      loading: false,
      error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchAccountDetails.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchAccountDetails.fulfilled, (state, action) => {
          state.loading = false;
          state.account = action.payload; // Store the fetched account data
        })
        .addCase(fetchAccountDetails.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message; // Handle error
        });
    },
  });
  
  // Export the actions and reducer
  export const selectAccountDetails = (state) => state.accountDetails;
  export default accountDetailsSlice.reducer;